/**
 * Função limpar filtros
 */
export function cleanFilter() {
  const cleanFilterButton = document.getElementById('btn_limpar_filtros')
  cleanFilterButton.addEventListener('click', () => {
    // reset nos inputs de texto
    const searchFields = document.querySelectorAll('[_filter_text_field]')
    searchFields.forEach((inputText) => {
      inputText.value = ''
    })

    // reset nos dropDowns
    const dropDowns = document.querySelectorAll('[_filter_drop_down]')
    dropDowns.forEach((dropDown) => {
      dropDown.innerText = dropDown.getAttribute('_default_value')
    })

    // reset nos checkboxes
    const checkboxes = document.querySelectorAll('[_filter_checkbox_field]')
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false
      checkbox.parentElement.classList.remove('container__checkbox--checked')
    })
  })
}
